import React, { useState , useEffect,useContext} from 'react';
import { Typeahead } from 'react-bootstrap-typeahead';
import Form from 'react-bootstrap/Form';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import './SearchDropDown.css';
import {AppContext} from '../../Context';
import _ from 'lodash';
export default function SearchDropDown(props){
    const [singleSelections, setSingleSelections] = useState([]);
    const [disable,setDisable] = useState(false);
    const {stateData ,setStateData} = useContext(AppContext);
        useEffect(() => {
      // console.log('singleSelections',singleSelections);
      props.selection?.(props?.placeholder,singleSelections[0]);
    },[singleSelections]);

    useEffect(()=>{
      if(!_.isEmpty(props?.dblclkselection) || !_.isUndefined(props?.dblclkselection)){
        setSingleSelections([props?.dblclkselection]);
        }

    },[props?.dblclkselection]);

  //  console.log("Nikhil",stateData.selected.District);
    function setOption(obj){
      // console.log(obj);
      // console.log(singleSelections);
      setSingleSelections(obj);
     
    }
    function getBoolData(props){
      if(props?.id === 'empbr' && props?.options?.length === 1) return true;
      if(props?.id === 'empbr' && stateData.selected.State!='') return true;
      else return false;
    }

    function getSelected(){
      // if(_.isEmpty(props?.dblclkselection) || _.isUndefined(props?.dblclkselection)){
      //   return singleSelections;
      // }else{
       // setSingleSelections([props?.dblclkselection]);
        return singleSelections;
      // }
    }

    return(
        <React.Fragment>
    <Form.Group>
      {/* <div className="container fluid"> */}
      <div className="">

        <Typeahead
          inputProps={props?.placeholder === 'Dealers' && {
            style: {
              'width': '40vw',
              // 'borderRadius':'unset',
            }
          }}
          style={{borderRadius:'0'}}
          id = {props.placeholder}
          className="select-dropdown"
          labelKey="name"
          onChange={setOption}
          options={props?.options instanceof Array ? props?.options : []}
          placeholder={props?.placeholder}
          selected={props?.id === 'empbr' && props?.options?.length === 1 ? props?.options : getSelected()}
          // disabled = {props?.id === 'empbr' && props?.options?.length === 1 ? true : false}
          disabled={getBoolData(props)}
          
        />
        </div>
      </Form.Group>
      </React.Fragment>
    );
}